// extracted by mini-css-extract-plugin
export default {"header":"SimpleHeader_header__QU54l","inner":"SimpleHeader_inner__u9X1i","logoLink":"SimpleHeader_logoLink__4wxA-","back":"SimpleHeader_back__iXSKz"};